<template>
    <vx-expandable-card id="details">
        <template v-slot:header>Phone Numbers</template>
        <template v-slot:headerSubtitle>
            {{ onCorporate() ? 'Numbers must be managed by a Voxie admin in' : 'Numbers must be managed by a Voxie admin.'}}
            <a v-if="onCorporate()" :href="`/settings/teams/${teamId}#/phone-numbers`" class="text-sky-700 underline">resources / phone numbers.</a>{{ " " }}
            <a href="https://support.voxie.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer" class="text-slate-500 underline">Contact Voxie</a> for help.
        </template>
        <template v-slot:content>
            <div class="flex flex-col gap-2">

              <template v-if="model.length">
                <div v-for="phoneNumber in model"
                     :key="phoneNumber.id"
                     class="rounded-lg px-5 w-full py-4 flex justify-between items-center text-slate-700"
                     :class="bgColor(phoneNumber.use_for_sending)">
                  <div class="self-center">
                    <slot name="icon">
                      <font-awesome-icon widthAuto :class="textColor(phoneNumber.use_for_sending)" :icon="faCirclePhone" />
                    </slot>
                  </div>
                  <div class="text-sm font-normal grow self-center pl-3">
                    <strong>{{ formatPhoneNumber(phoneNumber.phone_number) }}</strong> {{ phoneNumber.use_for_sending ? 'used for sending' : '' }}
                  </div>
                </div>
              </template>

                <div v-else class="rounded-lg bg-rose-100 px-5 w-full py-4 flex justify-between items-center text-slate-700">
                    <div class="self-center">
                        <slot name="icon">
                            <font-awesome-icon widthAuto class="text-rose-500" :icon="faTriangleExclamation" />
                        </slot>
                    </div>
                    <div class="text-sm font-normal grow self-center pl-3">
                        No numbers assigned
                    </div>
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { faCirclePhone, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { VxExpandableCard } from '@voxie/frontend-components';
import { formatPhoneNumber } from "~/components/filters";
import { useCurrentGroup } from "~/composables/useCurrentGroup";

const model = defineModel({default: []});
const teamId = Spark.state.currentTeam.id;

const bgColor = (usedForSending) => {
    return usedForSending ? 'bg-teal-100' : 'bg-slate-100';
};

const textColor = (usedForSending) => {
    return usedForSending ? 'text-teal-500' : 'text-slate-500';
};

const { onCorporate } = useCurrentGroup();
</script>
